import { queryOptions } from '@tanstack/react-query';
import { DeviceService } from './services/DeviceService';

export const deviceQueryKeys = {
  all: ['devices'] as const,
  list: () => [...deviceQueryKeys.all, 'list'] as const,
  detail: (id: number) => [...deviceQueryKeys.all, 'detail', id] as const,
  types: () => [...deviceQueryKeys.all, 'types'] as const,
  parameters: (deviceId: number) => [...deviceQueryKeys.all, 'parameters', deviceId] as const,
};

export const deviceQueries = {
  list: () =>
    queryOptions({
      queryKey: deviceQueryKeys.list(),
      queryFn: () => DeviceService.getList(),
    }),

  listByEnergySystem: (energySystemId: number) =>
    queryOptions({
      ...deviceQueries.list(),
      select: (data) => data.filter((d) => d.energySystem === energySystemId),
    }),

  detail: (id: number) =>
    queryOptions({
      queryKey: deviceQueryKeys.detail(id),
      queryFn: () => DeviceService.getById(id),
    }),

  types: () =>
    queryOptions({
      queryKey: deviceQueryKeys.types(),
      queryFn: () => DeviceService.getTypes(),
    }),

  parameters: (deviceId: number) =>
    queryOptions({
      queryKey: deviceQueryKeys.parameters(deviceId),
      queryFn: () => DeviceService.getParameters(deviceId),
    }),
};
